// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from 'services/api';

export class TermsAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  async fetchTerms(): Promise<string> {
    return this.Axios.get(`/text/terms`).then((res) => res.data);
  }

  async fetchPrivacy(): Promise<string> {
    return this.Axios.get(`/text/privacy`).then((res) => res.data);
  }
}
